import { render } from "./EventFullLog.vue?vue&type=template&id=5199abc0&scoped=true"
import script from "./EventFullLog.vue?vue&type=script&lang=js"
export * from "./EventFullLog.vue?vue&type=script&lang=js"

import "./EventFullLog.vue?vue&type=style&index=0&id=5199abc0&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5199abc0"]])

export default __exports__